module.exports = __webpack_public_path__ + "img/ic_notification.ca3642d6.svg";